import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../../api/api";
import ShowImageModel from "../../../components/common/modal/ShowImageModel";
import Images from "../../../media/images";

const Photos = () => {
  const [gallery, setGallery] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [categories, setCategories] = useState()
  const [categoryName, setCategoryName] = useState([])
  
  
  // useEffect(() => {
  //   gallery.data?.map((item, index) => {
  //     console.log("gallery", item);

  //     if (item["media_type"] === "IM") {
  //       // let item_data = item;
  //       // console.log(item);
  //       setfetchImages((gallery) => [...gallery, item]);
  //       // setCategories()
  //     }
  //     // console.log("data fetched");
  //     // console.log(gallery);
  //   });
  //   // }
  // }, []);

  // useEffect(() => {
  //   api.get(`/gallery/?category=test/`)
  //   .then(response=> {
  //     console.log(response.data)
  //   })
  // }, [categories])
  




//   useEffect(() => {

// gallery?.data?.map((item)=>

// console.log("iten",item)
// (setCategories(item))
//  )


//   }, [])
  
useEffect(() => {
 
api
.get("/gallery/media/?media_type=IM")
.then((resp)=>{
  setGallery(resp.data)
})
.catch((error)=>{
  toast("Something went wrong")
})
console.log("new gallery",gallery)

}, [])


console.log("Galllery ",gallery)
useEffect(() => {
 
  api
  .get("/gallery/media/categories/")
  .then((resp)=>{
    setCategoryName(resp.data)
  })
  .catch((error)=>{
    toast("Something went wrong")
  })
  
  
  }, [])
console.log("Gallery",gallery)

  return (
    <>
      {/* {gallery?.map((value, index) => {
        console.log("value", value);
        return (
          <Link
            key={index}
            to={`${value?.album_title.replace(" ", "-")}`}
            className="about-button font-Acme !bg-primary-red"
          >
            {value.id}
          </Link>
        );
      })} */}
      <div className="animation mt-8  flex-wrap items-center justify-center gap-6 bg-white">
        <div className="text-center">
  <div className=" flex justify-center gap-3">
     {
categoryName?.map((item,index)=>{
  return(

<div onClick={()=>setCategories(item.name)} className="bg-primary-red text-white-3 rounded-xl  text-white text-2xl p-2 cursor-pointer">{item.name}</div>
  )
})
     }     
   </div>
          {/* <div className="mt-4">
            <img alt="" src={Images.title_border} className="mx-auto" />
          </div> */}
          {/*  */}
        </div>
        <div className="px-10 ">
          <div className="grid grid-cols-1 items-center justify-center gap-7 text-white sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {gallery?.filter((value)=>value.category.name===categories).map((item, index) => {
              return (
                <div
                  key={index}
                  className=""
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalPreview"
                >
                  <div>
                    <div
                      key={index}
                      onClick={() => setImgLink(item.image)}
                      // to={`${item?.album_title.replace(" ", "-")}`}
                      className=""
                    >
                      {item.id}
                      <img
                        src={item.image}
                        alt=""
                        className="h-72 w-full bg-cover"
                      />
                      <ShowImageModel imgLink={imgLink} />
                    </div>
                  </div>
                </div>  
              // <div></div>
              );
            })}
          </div>
        </div>

        <div className="font-Berkshire mt-5 flex justify-center">
          <div
            // to={`${value.id.replace(" ", "-")}`}
            className="!bg-primary-red rounded-full py-1 px-2 text-white"
          >
            View More
          </div>
        </div>
      </div>
    </>
  );
};

export default Photos;
